/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProximityZone } from './ProximityZone';
import {
    ProximityZoneFromJSON,
    ProximityZoneFromJSONTyped,
    ProximityZoneToJSON,
    ProximityZoneToJSONTyped,
} from './ProximityZone';
import type { BadgeAntennaBType } from './BadgeAntennaBType';
import {
    BadgeAntennaBTypeFromJSON,
    BadgeAntennaBTypeFromJSONTyped,
    BadgeAntennaBTypeToJSON,
    BadgeAntennaBTypeToJSONTyped,
} from './BadgeAntennaBType';

/**
 * 
 * @export
 * @interface BadgeZoneViolationEvent
 */
export interface BadgeZoneViolationEvent {
    /**
     * 
     * @type {string}
     * @memberof BadgeZoneViolationEvent
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof BadgeZoneViolationEvent
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof BadgeZoneViolationEvent
     */
    time: Date;
    /**
     * 
     * @type {string}
     * @memberof BadgeZoneViolationEvent
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BadgeZoneViolationEvent
     */
    vehicleId: string;
    /**
     * 
     * @type {boolean}
     * @memberof BadgeZoneViolationEvent
     */
    isMuted: boolean;
    /**
     * 
     * @type {ProximityZone}
     * @memberof BadgeZoneViolationEvent
     */
    triggeredZone: ProximityZone;
    /**
     * ELOshield pedestrian badge that triggered the event.
     * @type {string}
     * @memberof BadgeZoneViolationEvent
     */
    pedestrianDeviceId: string;
    /**
     * 
     * @type {BadgeAntennaBType}
     * @memberof BadgeZoneViolationEvent
     */
    badgeAntennaBType: BadgeAntennaBType;
    /**
     * 
     * @type {number}
     * @memberof BadgeZoneViolationEvent
     */
    minimumDistanceCm?: number | null;
}



/**
 * Check if a given object implements the BadgeZoneViolationEvent interface.
 */
export function instanceOfBadgeZoneViolationEvent(value: object): value is BadgeZoneViolationEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('isMuted' in value) || value['isMuted'] === undefined) return false;
    if (!('triggeredZone' in value) || value['triggeredZone'] === undefined) return false;
    if (!('pedestrianDeviceId' in value) || value['pedestrianDeviceId'] === undefined) return false;
    if (!('badgeAntennaBType' in value) || value['badgeAntennaBType'] === undefined) return false;
    return true;
}

export function BadgeZoneViolationEventFromJSON(json: any): BadgeZoneViolationEvent {
    return BadgeZoneViolationEventFromJSONTyped(json, false);
}

export function BadgeZoneViolationEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): BadgeZoneViolationEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'time': (new Date(json['time'])),
        'userId': json['userId'] == null ? undefined : json['userId'],
        'vehicleId': json['vehicleId'],
        'isMuted': json['isMuted'],
        'triggeredZone': ProximityZoneFromJSON(json['triggeredZone']),
        'pedestrianDeviceId': json['pedestrianDeviceId'],
        'badgeAntennaBType': BadgeAntennaBTypeFromJSON(json['badgeAntennaBType']),
        'minimumDistanceCm': json['minimumDistanceCm'] == null ? undefined : json['minimumDistanceCm'],
    };
}

export function BadgeZoneViolationEventToJSON(json: any): BadgeZoneViolationEvent {
    return BadgeZoneViolationEventToJSONTyped(json, false);
}

export function BadgeZoneViolationEventToJSONTyped(value?: BadgeZoneViolationEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'time': value['time'].toISOString(),
        'userId': value['userId'],
        'vehicleId': value['vehicleId'],
        'isMuted': value['isMuted'],
        'triggeredZone': ProximityZoneToJSON(value['triggeredZone']),
        'pedestrianDeviceId': value['pedestrianDeviceId'],
        'badgeAntennaBType': BadgeAntennaBTypeToJSON(value['badgeAntennaBType']),
        'minimumDistanceCm': value['minimumDistanceCm'],
    };
}

